import * as React from 'react';
import { FC, HtmlHTMLAttributes, memo } from 'react';
import { get } from 'lodash';
import { Link, Typography } from '@material-ui/core';
import { FieldProps, InjectedFieldProps } from 'react-admin';
import { Phone } from '../interfaces/phone.interface';

export const PhoneField: FC<PhoneFieldProps> = memo<PhoneFieldProps>(
	({ className, emptyText, source, record = {}, ...rest }: any) => {
		const value: Phone = get(record, source);

		if (value == null || value.phone == null) {
			if (emptyText) {
				return (
					<Typography
						component="span"
						variant="body2"
						className={className}
					>
						{emptyText}
					</Typography>
				);
			} else {
				return <></>;
			}
		}

		return (
			<Link
				onClick={e => e.stopPropagation()}
				className={className}
				href={`tel:+${value.prefix}${value.phone}`}
			>
				{`+(${value.prefix})-${value.phone}`}
			</Link>
		);
	}
);

PhoneField.defaultProps = {
	addLabel: true
};

PhoneField.displayName = 'PhoneField';

export interface PhoneFieldProps
	extends FieldProps,
		InjectedFieldProps,
		HtmlHTMLAttributes<HTMLAnchorElement> {
}
